<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>

                <van-field
                        v-model="formData.station_name"
                        label="场次"
                        input-align="right"
                        readonly
                />
                <van-field
                        v-model="formData.danwei"
                        :rules="[{ required: true, message: '单位名称不能为空' }]"
                        label="单位名称"
                        input-align="right"
                        error-message-align="right"
                        left-icon="question-o"
                        @click-left-icon="onQuestion('danwei')"
                        clearable
                        placeholder="请输入单位名称"
                />

                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.province?formData.province+'/'+formData.city+'/'+formData.county:''"
                        input-align="right"
                        label="省市地区"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>
                <van-field
                        v-model="formData.address"
                        :rules="[{ required: true, message: '请输入详细地址' }]"
                        error-message-align="right"
                        label="详细地址"
                        input-align="right"
                        clearable
                        placeholder="请输入详细地址"
                />

                <van-field
                        v-model="formData.name"
                        label="联系人"
                        :rules="[{ required: true, message: '联系人不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入联系人姓名"
                />


                <van-field
                        v-model="formData.phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="联系人手机"
                        input-align="right"
                        clearable
                        placeholder="请输入手机"
                />
            </van-cell-group>


            <van-divider>收件人信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="formData.post_address"
                        :rules="[{ required: true, message: '请输入收件地址' }]"
                        error-message-align="right"
                        label="收件地址"
                        input-align="right"
                        clearable
                        placeholder="请输入收件地址"
                />
                <div  class="operate-desc-left">收取物料的邮寄地址</div>

                <van-field
                        v-model="formData.post_name"
                        label="收件人"
                        :rules="[{ required: true, message: '收件人不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入收件人姓名"
                />


                <van-field
                        v-model="formData.post_phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="收件人手机"
                        input-align="right"
                        clearable
                        placeholder="请输入收件人手机"
                />
            </van-cell-group>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-left: 10px;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,DatetimePicker,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Calendar} from 'vant';

    Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                station_id: this.$route.query.station_id,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{
                },
                formData: {
                    id: 0,
                    station_id: this.$route.query.station_id,
                    danwei:'',
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id||0;
            this.fetch();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/cba/applySave', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:'CbaApplyList',
                        query:{
                        }
                    })
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/cba/applyformdetail', {
                    station_id : that.station_id,
                    id : that.formData.id,
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// CbaApplyFormBasic.vue?a6532fee